import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import DatabasesList from './DatabasesList';

interface DatabasesDialogProps {
  open: boolean;
  onClose: () => void;
}

const DatabasesDialog: React.FC<DatabasesDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Available Databases</DialogTitle>

      <DialogContent dividers>
        <DatabasesList />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DatabasesDialog;
